import { Component } from "@angular/core";
import { AbstractModal } from "src/app/shared/components/modal/abstractModal";

@Component({
    selector: "oe-common-grid-history-details-new-navigation",
    templateUrl: "./new-navigation.html",
    standalone: false,
})
export class CommonGridExternalLimitationOverviewComponent extends AbstractModal { }
